import { Component, OnInit, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { Task } from 'src/classes/task';
import { Contact } from 'src/classes/contact';
import { extractRuleFromScheduleData } from 'src/utils/extractRuleFromScheduleData';
import { extractFilterFromDeliveryJSONArray } from 'src/utils/extractFilterFromDeliveryJSON';
import { Schedule, getLocalTimeString } from 'src/classes/schedule';
import { Delivery } from 'src/classes/delivery';

@Component({
  selector: 'app-task-revision',
  templateUrl: './task-revision.component.html',
  styleUrls: [
    './task-revision.component.scss',
    './../task-form.component.scss'
  ]
})
export class TaskRevisionComponent implements OnInit {

  @Input() task: Task;
  @Input() contacts: Contact[];

  constructor() { }

  ngOnInit() {
    if (!this.task) {
      console.warn('Missing task parameter');
    }
    console.log(this.task);
  }

  getContactNames(ids: number[]) {
    if (!(this.contacts instanceof Array) || this.contacts.length === 0) {
      return ids;
    }
    return ids.map(id => {
      const c = this.contacts.find(contact => contact.idContact.toString() === id.toString());
      return c ? c.name : undefined;
    }).filter(contact => contact !== undefined);
  }

  getTypeLabel(schedule: Schedule) {
    return {
      H: 'Hourly',
      D: 'Daily',
      W: 'Weekly',
      M: 'Monthly'
    }[schedule.type];
  }

  getRuleLabel(schedule: Schedule) {
    return extractRuleFromScheduleData(schedule.type, schedule.rule);
  }

  getFilterLabel(delivery: Delivery): string[] {
    const list = extractFilterFromDeliveryJSONArray(delivery.filters);
    if (list.length === 0) {
      return ['None'];
    }
    return list;
  }

  getTaskPageArray() {
    const pages: any = this.task.objects.map(i=>i.name);
    return typeof pages === 'string' ? pages.split(",") : pages;
  }

  getScheduleLocalTime(schedule: Schedule) {
    return getLocalTimeString(schedule);
  }

}
